(function () {
  /**
   * Generates an ICS (iCalendar) content for a given event.
   *
   * @param {Object} eventData - The event data.
   * @param {string} eventData.startDate - The start date of the event in a recognizable format.
   * @param {string} eventData.endDate - The end date of the event in a recognizable format.
   * @param {string} eventData.location - The location of the event.
   * @param {string} eventData.description - The description of the event.
   * @param {string} eventData.title - The title of the event.
   * @return {string} - The ICS content for the all-day event.
   */
  function generateICS(eventData) {
    const formatICSDateForAllDay = (dateStr) => {
      const date = new Date(dateStr);
      return date.toISOString().split("T")[0].replace(/-/g, "");
    };

    // Move to the day after the event.
    const endOfDay = new Date(eventData.endDate);
    endOfDay.setDate(endOfDay.getDate() + 1);

    return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Siemens AG//Siemens Xcelerator Developer Portal//EN
BEGIN:VEVENT
DTSTART;VALUE=DATE:${formatICSDateForAllDay(eventData.startDate)}
DTEND;VALUE=DATE:${formatICSDateForAllDay(endOfDay.toISOString())}
LOCATION:${eventData.location}
DESCRIPTION:${eventData.description}
SUMMARY:${eventData.title}
END:VEVENT
END:VCALENDAR`;
  }

  const container = document.querySelector(".upcoming-events-container");

  let hasEvents = false;
  fetch("./assets/javascripts/upcoming-events.json")
    .then((response) => response.json())
    .then((data) => {
      const currentDate = new Date();
      data.events.forEach((eventData) => {
        // Skip past events.
        const eventEndDate = new Date(eventData.endDate);
        if (eventEndDate < currentDate) {
          return;
        }

        hasEvents = true;

        const event = document.createElement("div");
        event.classList.add("promo-block");

        const innerDiv = document.createElement("div");
        innerDiv.classList.add("promo-block-inner");
        event.appendChild(innerDiv);

        // Image is optional.
        if (eventData.image) {
          const imgElem = document.createElement("img");
          imgElem.src = eventData.image;
          const figure = document.createElement("figure");
          figure.classList.add("promo-image");
          figure.appendChild(imgElem);
          innerDiv.appendChild(figure);
        }

        const bodyDiv = document.createElement("div");
        bodyDiv.classList.add("promo-body");
        innerDiv.appendChild(bodyDiv);

        const eventInfoDiv = document.createElement("div");
        eventInfoDiv.classList.add("event-info");
        if (eventData.location) {
          eventInfoDiv.textContent = `${eventData.location}, `;
        }
        eventInfoDiv.textContent += `${eventData.startDate} - ${eventData.endDate}`;
        bodyDiv.appendChild(eventInfoDiv);

        const h3 = document.createElement("h3");
        const a = document.createElement("a");
        if (eventData.titleLink) {
          a.href = eventData.titleLink;
          a.textContent = eventData.title;
          h3.appendChild(a);
        } else {
          h3.textContent = eventData.title;
        }
        bodyDiv.appendChild(h3);

        eventData.description.forEach((paragraph) => {
          const p = document.createElement("p");
          p.innerHTML = paragraph;
          bodyDiv.appendChild(p);
        });

        if (eventData.subscribeLink) {
          const buttonsWrapper = document.createElement("div");
          buttonsWrapper.classList.add("buttons-wrapper");

          const subscribeButton = document.createElement("a");
          subscribeButton.classList.add("button", "button-primary");
          subscribeButton.href = eventData.subscribeLink;
          subscribeButton.textContent = eventData.subscribeLinkText;
          subscribeButton.setAttribute("aria-label", "Subscribe to upcoming events");
          buttonsWrapper.appendChild(subscribeButton);

          const saveDateButton = document.createElement("a");
          saveDateButton.classList.add("button", "button-tertiary");
          saveDateButton.href = "data:text/calendar;charset=utf8," + encodeURIComponent(generateICS(eventData));
          saveDateButton.download = "event.ics";
          saveDateButton.textContent = "Save the date";
          buttonsWrapper.appendChild(saveDateButton);

          bodyDiv.appendChild(buttonsWrapper);
        }

        container.appendChild(event);
      });

      if (hasEvents) {
        const header = document.createElement("h2");
        header.textContent = "Upcoming Events";
        container.insertBefore(header, container.firstChild);
      } else {
        container.remove();
      }
    })
    .catch((error) => {
      console.error("Error fetching event data:", error);
      container.remove();
    });
})();
